/**
 * @module config/submit-transformer
 * @description Export submit transformer for VA Form 21-4192
 */

export { transformForSubmit } from './submit-transformer';
